
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as resetknaAbE8PExNaSzVauanasyBLY6z6kf5BwsYT9W1SyXkMeta } from "/app/pages/auth/reset.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta } from "/app/pages/admin/login.vue?macro=true";
import { default as _91id_93IVmlC0yrx23DcEGigwH1M7rC6QZXq5xU5mG_U8Qm0O4Meta } from "/app/pages/public/[id].vue?macro=true";
import { default as logoutRhBAEoteFvB7eUgLSG96KDmWfKmBYl2spAe2p9kHsycMeta } from "/app/pages/admin/logout.vue?macro=true";
import { default as profile5k5vtiSyQyYiZEu4MaSnWXv0WRuRTfTShdWLs8DEpZAMeta } from "/app/pages/auth/profile.vue?macro=true";
import { default as forgottenaumonlu_3OJo0_45Rd4rSSS7QlCt5u2FfLygcnDuqtQ_kMeta } from "/app/pages/auth/forgotten.vue?macro=true";
import { default as indexirBOTnaNwmrPfgqxKPc24VhCFOyyli1sfv0vhA8jW_AMeta } from "/app/pages/projects/index.vue?macro=true";
import { default as indexR1ROsp4DRizyMyAu82w_45LZoK4UeISEuCoeYwxeo5m24Meta } from "/app/pages/followups/index.vue?macro=true";
import { default as indexFACMocgF5DubJUHoL29eHRdMQtmOGHp_45sgkdHQegGr8Meta } from "/app/pages/admin/tags/index.vue?macro=true";
import { default as indexp6CTEswQFS_45wYm62VFpYAZw5fupx_9ZNzAmu9kDAqWQMeta } from "/app/pages/admin/forms/index.vue?macro=true";
import { default as _91id_93Qx2rjoqM_VqqyaAvO0MPxgIQAkbNyruKD6cSRkw5XdsMeta } from "/app/pages/admin/projects/[id].vue?macro=true";
import { default as index3CATpM95HeV3MoyCOgIJKANbezskurIaJF34uN9r7j0Meta } from "/app/pages/admin/managers/index.vue?macro=true";
import { default as indexxYlVMlbFSvZab7H8ux8bcOhv9zWnbjUh1Rvj8H92tIQMeta } from "/app/pages/admin/projects/index.vue?macro=true";
import { default as indexXY6RbreGjjwxXxJECyEUZu47PUGrWu8RqXTfNdu53soMeta } from "/app/pages/admin/followups/index.vue?macro=true";
import { default as _91id_93Ybx57XTLuRrS7RiGai7EW6_45PHf6EuXm9CLrIQL8ZrO0Meta } from "/app/pages/admin/forms/edit/[id].vue?macro=true";
import { default as _91id_93LUTeHE0Nl25bfOxGG_45WhaeP7YdnNUCg8kOvHDe_45JS1QMeta } from "/app/pages/projects/[projectId]/cases/[id].vue?macro=true";
import { default as indexH6xtvfZUn3wB4EoeYM9zLHYF6GlUvXyYJLjLGUaQXSYMeta } from "/app/pages/projects/[projectId]/cases/index.vue?macro=true";
import { default as indexRoOxTs18NmYKqnLzaBbnvpW_jXL16vM5A4ZbEjIKAD8Meta } from "/app/pages/projects/[projectId]/forms/index.vue?macro=true";
import { default as index2fYNUruj3VKctIJuCe_klwTC7OVmeFaVRcx1UEJAcnYMeta } from "/app/pages/projects/[projectId]/users/index.vue?macro=true";
import { default as indextoRRmixNc8wxVgTfBISqU7qnEbeGX4VR6LeMA3BARlQMeta } from "/app/pages/projects/[projectId]/places/index.vue?macro=true";
import { default as _91id_93h7fTWnsrUI9nxIJbPvo7y7TF2YkoZDx_45iWFeyNR40AkMeta } from "/app/pages/projects/[projectId]/reports/[id].vue?macro=true";
import { default as indexHpl2oWM2_TCnJqaiPYrxuJt_933TKdyi3ie6KCJHPvMMeta } from "/app/pages/projects/[projectId]/reports/index.vue?macro=true";
import { default as indexIcHciSe7LBDyIU0YdSQ9M6psl_45DJYJS8qNtZIhbXsVcMeta } from "/app/pages/projects/[projectId]/workflow/index.vue?macro=true";
import { default as _91id_93urakgncuqIEPEPS2jxuuuHtMIyuXzt83Ko0ug396_8gMeta } from "/app/pages/projects/[projectId]/forms/edit/[id].vue?macro=true";
import { default as indexafwxobnLQiriAFtpwAuLougAYsQxSncm3JHtBNUMpXYMeta } from "/app/pages/projects/[projectId]/dashboards/index.vue?macro=true";
import { default as _91id_93vM11fsq6J23kR0Cy8Cv3nAT_45wALd70hBw3AOxfzvfwgMeta } from "/app/pages/projects/[projectId]/forms/report/[id].vue?macro=true";
import { default as indexgawb481sNlcBtKmv8ZaenE8mlk2xU8Zc1KEHJdsTLrcMeta } from "/app/pages/projects/[projectId]/organisations/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/en",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr___default",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___es",
    path: "/es/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___fr___default",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___fr",
    path: "/fr/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "auth-reset___en",
    path: "/en/auth/reset",
    meta: resetknaAbE8PExNaSzVauanasyBLY6z6kf5BwsYT9W1SyXkMeta || {},
    component: () => import("/app/pages/auth/reset.vue")
  },
  {
    name: "auth-reset___es",
    path: "/es/auth/reset",
    meta: resetknaAbE8PExNaSzVauanasyBLY6z6kf5BwsYT9W1SyXkMeta || {},
    component: () => import("/app/pages/auth/reset.vue")
  },
  {
    name: "auth-reset___fr___default",
    path: "/auth/reset",
    meta: resetknaAbE8PExNaSzVauanasyBLY6z6kf5BwsYT9W1SyXkMeta || {},
    component: () => import("/app/pages/auth/reset.vue")
  },
  {
    name: "auth-reset___fr",
    path: "/fr/auth/reset",
    meta: resetknaAbE8PExNaSzVauanasyBLY6z6kf5BwsYT9W1SyXkMeta || {},
    component: () => import("/app/pages/auth/reset.vue")
  },
  {
    name: "admin___en",
    path: "/en/admin",
    meta: indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin___es",
    path: "/es/admin",
    meta: indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin___fr___default",
    path: "/admin",
    meta: indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin___fr",
    path: "/fr/admin",
    meta: indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-login___en",
    path: "/en/admin/login",
    meta: loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta || {},
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "admin-login___es",
    path: "/es/admin/login",
    meta: loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta || {},
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "admin-login___fr___default",
    path: "/admin/login",
    meta: loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta || {},
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "admin-login___fr",
    path: "/fr/admin/login",
    meta: loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta || {},
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "public-id___en",
    path: "/en/public/:id()",
    meta: _91id_93IVmlC0yrx23DcEGigwH1M7rC6QZXq5xU5mG_U8Qm0O4Meta || {},
    component: () => import("/app/pages/public/[id].vue")
  },
  {
    name: "public-id___es",
    path: "/es/public/:id()",
    meta: _91id_93IVmlC0yrx23DcEGigwH1M7rC6QZXq5xU5mG_U8Qm0O4Meta || {},
    component: () => import("/app/pages/public/[id].vue")
  },
  {
    name: "public-id___fr___default",
    path: "/public/:id()",
    meta: _91id_93IVmlC0yrx23DcEGigwH1M7rC6QZXq5xU5mG_U8Qm0O4Meta || {},
    component: () => import("/app/pages/public/[id].vue")
  },
  {
    name: "public-id___fr",
    path: "/fr/public/:id()",
    meta: _91id_93IVmlC0yrx23DcEGigwH1M7rC6QZXq5xU5mG_U8Qm0O4Meta || {},
    component: () => import("/app/pages/public/[id].vue")
  },
  {
    name: "admin-logout___en",
    path: "/en/admin/logout",
    meta: logoutRhBAEoteFvB7eUgLSG96KDmWfKmBYl2spAe2p9kHsycMeta || {},
    component: () => import("/app/pages/admin/logout.vue")
  },
  {
    name: "admin-logout___es",
    path: "/es/admin/logout",
    meta: logoutRhBAEoteFvB7eUgLSG96KDmWfKmBYl2spAe2p9kHsycMeta || {},
    component: () => import("/app/pages/admin/logout.vue")
  },
  {
    name: "admin-logout___fr___default",
    path: "/admin/logout",
    meta: logoutRhBAEoteFvB7eUgLSG96KDmWfKmBYl2spAe2p9kHsycMeta || {},
    component: () => import("/app/pages/admin/logout.vue")
  },
  {
    name: "admin-logout___fr",
    path: "/fr/admin/logout",
    meta: logoutRhBAEoteFvB7eUgLSG96KDmWfKmBYl2spAe2p9kHsycMeta || {},
    component: () => import("/app/pages/admin/logout.vue")
  },
  {
    name: "auth-profile___en",
    path: "/en/auth/profile",
    component: () => import("/app/pages/auth/profile.vue")
  },
  {
    name: "auth-profile___es",
    path: "/es/auth/profile",
    component: () => import("/app/pages/auth/profile.vue")
  },
  {
    name: "auth-profile___fr___default",
    path: "/auth/profile",
    component: () => import("/app/pages/auth/profile.vue")
  },
  {
    name: "auth-profile___fr",
    path: "/fr/auth/profile",
    component: () => import("/app/pages/auth/profile.vue")
  },
  {
    name: "auth-forgotten___en",
    path: "/en/auth/forgotten",
    component: () => import("/app/pages/auth/forgotten.vue")
  },
  {
    name: "auth-forgotten___es",
    path: "/es/auth/forgotten",
    component: () => import("/app/pages/auth/forgotten.vue")
  },
  {
    name: "auth-forgotten___fr___default",
    path: "/auth/forgotten",
    component: () => import("/app/pages/auth/forgotten.vue")
  },
  {
    name: "auth-forgotten___fr",
    path: "/fr/auth/forgotten",
    component: () => import("/app/pages/auth/forgotten.vue")
  },
  {
    name: "projects___en",
    path: "/en/projects",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "projects___es",
    path: "/es/projects",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "projects___fr___default",
    path: "/projects",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "projects___fr",
    path: "/fr/projects",
    component: () => import("/app/pages/projects/index.vue")
  },
  {
    name: "followups___en",
    path: "/en/followups",
    meta: indexR1ROsp4DRizyMyAu82w_45LZoK4UeISEuCoeYwxeo5m24Meta || {},
    component: () => import("/app/pages/followups/index.vue")
  },
  {
    name: "followups___es",
    path: "/es/followups",
    meta: indexR1ROsp4DRizyMyAu82w_45LZoK4UeISEuCoeYwxeo5m24Meta || {},
    component: () => import("/app/pages/followups/index.vue")
  },
  {
    name: "followups___fr___default",
    path: "/followups",
    meta: indexR1ROsp4DRizyMyAu82w_45LZoK4UeISEuCoeYwxeo5m24Meta || {},
    component: () => import("/app/pages/followups/index.vue")
  },
  {
    name: "followups___fr",
    path: "/fr/followups",
    meta: indexR1ROsp4DRizyMyAu82w_45LZoK4UeISEuCoeYwxeo5m24Meta || {},
    component: () => import("/app/pages/followups/index.vue")
  },
  {
    name: "admin-tags___en",
    path: "/en/admin/tags",
    meta: indexFACMocgF5DubJUHoL29eHRdMQtmOGHp_45sgkdHQegGr8Meta || {},
    component: () => import("/app/pages/admin/tags/index.vue")
  },
  {
    name: "admin-tags___es",
    path: "/es/admin/tags",
    meta: indexFACMocgF5DubJUHoL29eHRdMQtmOGHp_45sgkdHQegGr8Meta || {},
    component: () => import("/app/pages/admin/tags/index.vue")
  },
  {
    name: "admin-tags___fr___default",
    path: "/admin/tags",
    meta: indexFACMocgF5DubJUHoL29eHRdMQtmOGHp_45sgkdHQegGr8Meta || {},
    component: () => import("/app/pages/admin/tags/index.vue")
  },
  {
    name: "admin-tags___fr",
    path: "/fr/admin/tags",
    meta: indexFACMocgF5DubJUHoL29eHRdMQtmOGHp_45sgkdHQegGr8Meta || {},
    component: () => import("/app/pages/admin/tags/index.vue")
  },
  {
    name: "admin-forms___en",
    path: "/en/admin/forms",
    meta: indexp6CTEswQFS_45wYm62VFpYAZw5fupx_9ZNzAmu9kDAqWQMeta || {},
    component: () => import("/app/pages/admin/forms/index.vue")
  },
  {
    name: "admin-forms___es",
    path: "/es/admin/forms",
    meta: indexp6CTEswQFS_45wYm62VFpYAZw5fupx_9ZNzAmu9kDAqWQMeta || {},
    component: () => import("/app/pages/admin/forms/index.vue")
  },
  {
    name: "admin-forms___fr___default",
    path: "/admin/forms",
    meta: indexp6CTEswQFS_45wYm62VFpYAZw5fupx_9ZNzAmu9kDAqWQMeta || {},
    component: () => import("/app/pages/admin/forms/index.vue")
  },
  {
    name: "admin-forms___fr",
    path: "/fr/admin/forms",
    meta: indexp6CTEswQFS_45wYm62VFpYAZw5fupx_9ZNzAmu9kDAqWQMeta || {},
    component: () => import("/app/pages/admin/forms/index.vue")
  },
  {
    name: "admin-projects-id___en",
    path: "/en/admin/projects/:id()",
    meta: _91id_93Qx2rjoqM_VqqyaAvO0MPxgIQAkbNyruKD6cSRkw5XdsMeta || {},
    component: () => import("/app/pages/admin/projects/[id].vue")
  },
  {
    name: "admin-projects-id___es",
    path: "/es/admin/projects/:id()",
    meta: _91id_93Qx2rjoqM_VqqyaAvO0MPxgIQAkbNyruKD6cSRkw5XdsMeta || {},
    component: () => import("/app/pages/admin/projects/[id].vue")
  },
  {
    name: "admin-projects-id___fr___default",
    path: "/admin/projects/:id()",
    meta: _91id_93Qx2rjoqM_VqqyaAvO0MPxgIQAkbNyruKD6cSRkw5XdsMeta || {},
    component: () => import("/app/pages/admin/projects/[id].vue")
  },
  {
    name: "admin-projects-id___fr",
    path: "/fr/admin/projects/:id()",
    meta: _91id_93Qx2rjoqM_VqqyaAvO0MPxgIQAkbNyruKD6cSRkw5XdsMeta || {},
    component: () => import("/app/pages/admin/projects/[id].vue")
  },
  {
    name: "admin-managers___en",
    path: "/en/admin/managers",
    meta: index3CATpM95HeV3MoyCOgIJKANbezskurIaJF34uN9r7j0Meta || {},
    component: () => import("/app/pages/admin/managers/index.vue")
  },
  {
    name: "admin-managers___es",
    path: "/es/admin/managers",
    meta: index3CATpM95HeV3MoyCOgIJKANbezskurIaJF34uN9r7j0Meta || {},
    component: () => import("/app/pages/admin/managers/index.vue")
  },
  {
    name: "admin-managers___fr___default",
    path: "/admin/managers",
    meta: index3CATpM95HeV3MoyCOgIJKANbezskurIaJF34uN9r7j0Meta || {},
    component: () => import("/app/pages/admin/managers/index.vue")
  },
  {
    name: "admin-managers___fr",
    path: "/fr/admin/managers",
    meta: index3CATpM95HeV3MoyCOgIJKANbezskurIaJF34uN9r7j0Meta || {},
    component: () => import("/app/pages/admin/managers/index.vue")
  },
  {
    name: "admin-projects___en",
    path: "/en/admin/projects",
    meta: indexxYlVMlbFSvZab7H8ux8bcOhv9zWnbjUh1Rvj8H92tIQMeta || {},
    component: () => import("/app/pages/admin/projects/index.vue")
  },
  {
    name: "admin-projects___es",
    path: "/es/admin/projects",
    meta: indexxYlVMlbFSvZab7H8ux8bcOhv9zWnbjUh1Rvj8H92tIQMeta || {},
    component: () => import("/app/pages/admin/projects/index.vue")
  },
  {
    name: "admin-projects___fr___default",
    path: "/admin/projects",
    meta: indexxYlVMlbFSvZab7H8ux8bcOhv9zWnbjUh1Rvj8H92tIQMeta || {},
    component: () => import("/app/pages/admin/projects/index.vue")
  },
  {
    name: "admin-projects___fr",
    path: "/fr/admin/projects",
    meta: indexxYlVMlbFSvZab7H8ux8bcOhv9zWnbjUh1Rvj8H92tIQMeta || {},
    component: () => import("/app/pages/admin/projects/index.vue")
  },
  {
    name: "admin-followups___en",
    path: "/en/admin/followups",
    meta: indexXY6RbreGjjwxXxJECyEUZu47PUGrWu8RqXTfNdu53soMeta || {},
    component: () => import("/app/pages/admin/followups/index.vue")
  },
  {
    name: "admin-followups___es",
    path: "/es/admin/followups",
    meta: indexXY6RbreGjjwxXxJECyEUZu47PUGrWu8RqXTfNdu53soMeta || {},
    component: () => import("/app/pages/admin/followups/index.vue")
  },
  {
    name: "admin-followups___fr___default",
    path: "/admin/followups",
    meta: indexXY6RbreGjjwxXxJECyEUZu47PUGrWu8RqXTfNdu53soMeta || {},
    component: () => import("/app/pages/admin/followups/index.vue")
  },
  {
    name: "admin-followups___fr",
    path: "/fr/admin/followups",
    meta: indexXY6RbreGjjwxXxJECyEUZu47PUGrWu8RqXTfNdu53soMeta || {},
    component: () => import("/app/pages/admin/followups/index.vue")
  },
  {
    name: "admin-forms-edit-id___en",
    path: "/en/admin/forms/edit/:id()",
    meta: _91id_93Ybx57XTLuRrS7RiGai7EW6_45PHf6EuXm9CLrIQL8ZrO0Meta || {},
    component: () => import("/app/pages/admin/forms/edit/[id].vue")
  },
  {
    name: "admin-forms-edit-id___es",
    path: "/es/admin/forms/edit/:id()",
    meta: _91id_93Ybx57XTLuRrS7RiGai7EW6_45PHf6EuXm9CLrIQL8ZrO0Meta || {},
    component: () => import("/app/pages/admin/forms/edit/[id].vue")
  },
  {
    name: "admin-forms-edit-id___fr___default",
    path: "/admin/forms/edit/:id()",
    meta: _91id_93Ybx57XTLuRrS7RiGai7EW6_45PHf6EuXm9CLrIQL8ZrO0Meta || {},
    component: () => import("/app/pages/admin/forms/edit/[id].vue")
  },
  {
    name: "admin-forms-edit-id___fr",
    path: "/fr/admin/forms/edit/:id()",
    meta: _91id_93Ybx57XTLuRrS7RiGai7EW6_45PHf6EuXm9CLrIQL8ZrO0Meta || {},
    component: () => import("/app/pages/admin/forms/edit/[id].vue")
  },
  {
    name: "projects-projectId-cases-id___en",
    path: "/en/projects/:projectId()/cases/:id()",
    component: () => import("/app/pages/projects/[projectId]/cases/[id].vue")
  },
  {
    name: "projects-projectId-cases-id___es",
    path: "/es/projects/:projectId()/cases/:id()",
    component: () => import("/app/pages/projects/[projectId]/cases/[id].vue")
  },
  {
    name: "projects-projectId-cases-id___fr___default",
    path: "/projects/:projectId()/cases/:id()",
    component: () => import("/app/pages/projects/[projectId]/cases/[id].vue")
  },
  {
    name: "projects-projectId-cases-id___fr",
    path: "/fr/projects/:projectId()/cases/:id()",
    component: () => import("/app/pages/projects/[projectId]/cases/[id].vue")
  },
  {
    name: "projects-projectId-cases___en",
    path: "/en/projects/:projectId()/cases",
    component: () => import("/app/pages/projects/[projectId]/cases/index.vue")
  },
  {
    name: "projects-projectId-cases___es",
    path: "/es/projects/:projectId()/cases",
    component: () => import("/app/pages/projects/[projectId]/cases/index.vue")
  },
  {
    name: "projects-projectId-cases___fr___default",
    path: "/projects/:projectId()/cases",
    component: () => import("/app/pages/projects/[projectId]/cases/index.vue")
  },
  {
    name: "projects-projectId-cases___fr",
    path: "/fr/projects/:projectId()/cases",
    component: () => import("/app/pages/projects/[projectId]/cases/index.vue")
  },
  {
    name: "projects-projectId-forms___en",
    path: "/en/projects/:projectId()/forms",
    component: () => import("/app/pages/projects/[projectId]/forms/index.vue")
  },
  {
    name: "projects-projectId-forms___es",
    path: "/es/projects/:projectId()/forms",
    component: () => import("/app/pages/projects/[projectId]/forms/index.vue")
  },
  {
    name: "projects-projectId-forms___fr___default",
    path: "/projects/:projectId()/forms",
    component: () => import("/app/pages/projects/[projectId]/forms/index.vue")
  },
  {
    name: "projects-projectId-forms___fr",
    path: "/fr/projects/:projectId()/forms",
    component: () => import("/app/pages/projects/[projectId]/forms/index.vue")
  },
  {
    name: "projects-projectId-users___en",
    path: "/en/projects/:projectId()/users",
    meta: index2fYNUruj3VKctIJuCe_klwTC7OVmeFaVRcx1UEJAcnYMeta || {},
    component: () => import("/app/pages/projects/[projectId]/users/index.vue")
  },
  {
    name: "projects-projectId-users___es",
    path: "/es/projects/:projectId()/users",
    meta: index2fYNUruj3VKctIJuCe_klwTC7OVmeFaVRcx1UEJAcnYMeta || {},
    component: () => import("/app/pages/projects/[projectId]/users/index.vue")
  },
  {
    name: "projects-projectId-users___fr___default",
    path: "/projects/:projectId()/users",
    meta: index2fYNUruj3VKctIJuCe_klwTC7OVmeFaVRcx1UEJAcnYMeta || {},
    component: () => import("/app/pages/projects/[projectId]/users/index.vue")
  },
  {
    name: "projects-projectId-users___fr",
    path: "/fr/projects/:projectId()/users",
    meta: index2fYNUruj3VKctIJuCe_klwTC7OVmeFaVRcx1UEJAcnYMeta || {},
    component: () => import("/app/pages/projects/[projectId]/users/index.vue")
  },
  {
    name: "projects-projectId-places___en",
    path: "/en/projects/:projectId()/places",
    component: () => import("/app/pages/projects/[projectId]/places/index.vue")
  },
  {
    name: "projects-projectId-places___es",
    path: "/es/projects/:projectId()/places",
    component: () => import("/app/pages/projects/[projectId]/places/index.vue")
  },
  {
    name: "projects-projectId-places___fr___default",
    path: "/projects/:projectId()/places",
    component: () => import("/app/pages/projects/[projectId]/places/index.vue")
  },
  {
    name: "projects-projectId-places___fr",
    path: "/fr/projects/:projectId()/places",
    component: () => import("/app/pages/projects/[projectId]/places/index.vue")
  },
  {
    name: "projects-projectId-reports-id___en",
    path: "/en/projects/:projectId()/reports/:id()",
    component: () => import("/app/pages/projects/[projectId]/reports/[id].vue")
  },
  {
    name: "projects-projectId-reports-id___es",
    path: "/es/projects/:projectId()/reports/:id()",
    component: () => import("/app/pages/projects/[projectId]/reports/[id].vue")
  },
  {
    name: "projects-projectId-reports-id___fr___default",
    path: "/projects/:projectId()/reports/:id()",
    component: () => import("/app/pages/projects/[projectId]/reports/[id].vue")
  },
  {
    name: "projects-projectId-reports-id___fr",
    path: "/fr/projects/:projectId()/reports/:id()",
    component: () => import("/app/pages/projects/[projectId]/reports/[id].vue")
  },
  {
    name: "projects-projectId-reports___en",
    path: "/en/projects/:projectId()/reports",
    component: () => import("/app/pages/projects/[projectId]/reports/index.vue")
  },
  {
    name: "projects-projectId-reports___es",
    path: "/es/projects/:projectId()/reports",
    component: () => import("/app/pages/projects/[projectId]/reports/index.vue")
  },
  {
    name: "projects-projectId-reports___fr___default",
    path: "/projects/:projectId()/reports",
    component: () => import("/app/pages/projects/[projectId]/reports/index.vue")
  },
  {
    name: "projects-projectId-reports___fr",
    path: "/fr/projects/:projectId()/reports",
    component: () => import("/app/pages/projects/[projectId]/reports/index.vue")
  },
  {
    name: "projects-projectId-workflow___en",
    path: "/en/projects/:projectId()/workflow",
    meta: indexIcHciSe7LBDyIU0YdSQ9M6psl_45DJYJS8qNtZIhbXsVcMeta || {},
    component: () => import("/app/pages/projects/[projectId]/workflow/index.vue")
  },
  {
    name: "projects-projectId-workflow___es",
    path: "/es/projects/:projectId()/workflow",
    meta: indexIcHciSe7LBDyIU0YdSQ9M6psl_45DJYJS8qNtZIhbXsVcMeta || {},
    component: () => import("/app/pages/projects/[projectId]/workflow/index.vue")
  },
  {
    name: "projects-projectId-workflow___fr___default",
    path: "/projects/:projectId()/workflow",
    meta: indexIcHciSe7LBDyIU0YdSQ9M6psl_45DJYJS8qNtZIhbXsVcMeta || {},
    component: () => import("/app/pages/projects/[projectId]/workflow/index.vue")
  },
  {
    name: "projects-projectId-workflow___fr",
    path: "/fr/projects/:projectId()/workflow",
    meta: indexIcHciSe7LBDyIU0YdSQ9M6psl_45DJYJS8qNtZIhbXsVcMeta || {},
    component: () => import("/app/pages/projects/[projectId]/workflow/index.vue")
  },
  {
    name: "projects-projectId-forms-edit-id___en",
    path: "/en/projects/:projectId()/forms/edit/:id()",
    component: () => import("/app/pages/projects/[projectId]/forms/edit/[id].vue")
  },
  {
    name: "projects-projectId-forms-edit-id___es",
    path: "/es/projects/:projectId()/forms/edit/:id()",
    component: () => import("/app/pages/projects/[projectId]/forms/edit/[id].vue")
  },
  {
    name: "projects-projectId-forms-edit-id___fr___default",
    path: "/projects/:projectId()/forms/edit/:id()",
    component: () => import("/app/pages/projects/[projectId]/forms/edit/[id].vue")
  },
  {
    name: "projects-projectId-forms-edit-id___fr",
    path: "/fr/projects/:projectId()/forms/edit/:id()",
    component: () => import("/app/pages/projects/[projectId]/forms/edit/[id].vue")
  },
  {
    name: "projects-projectId-dashboards___en",
    path: "/en/projects/:projectId()/dashboards",
    component: () => import("/app/pages/projects/[projectId]/dashboards/index.vue")
  },
  {
    name: "projects-projectId-dashboards___es",
    path: "/es/projects/:projectId()/dashboards",
    component: () => import("/app/pages/projects/[projectId]/dashboards/index.vue")
  },
  {
    name: "projects-projectId-dashboards___fr___default",
    path: "/projects/:projectId()/dashboards",
    component: () => import("/app/pages/projects/[projectId]/dashboards/index.vue")
  },
  {
    name: "projects-projectId-dashboards___fr",
    path: "/fr/projects/:projectId()/dashboards",
    component: () => import("/app/pages/projects/[projectId]/dashboards/index.vue")
  },
  {
    name: "projects-projectId-forms-report-id___en",
    path: "/en/projects/:projectId()/forms/report/:id()",
    component: () => import("/app/pages/projects/[projectId]/forms/report/[id].vue")
  },
  {
    name: "projects-projectId-forms-report-id___es",
    path: "/es/projects/:projectId()/forms/report/:id()",
    component: () => import("/app/pages/projects/[projectId]/forms/report/[id].vue")
  },
  {
    name: "projects-projectId-forms-report-id___fr___default",
    path: "/projects/:projectId()/forms/report/:id()",
    component: () => import("/app/pages/projects/[projectId]/forms/report/[id].vue")
  },
  {
    name: "projects-projectId-forms-report-id___fr",
    path: "/fr/projects/:projectId()/forms/report/:id()",
    component: () => import("/app/pages/projects/[projectId]/forms/report/[id].vue")
  },
  {
    name: "projects-projectId-organisations___en",
    path: "/en/projects/:projectId()/organisations",
    component: () => import("/app/pages/projects/[projectId]/organisations/index.vue")
  },
  {
    name: "projects-projectId-organisations___es",
    path: "/es/projects/:projectId()/organisations",
    component: () => import("/app/pages/projects/[projectId]/organisations/index.vue")
  },
  {
    name: "projects-projectId-organisations___fr___default",
    path: "/projects/:projectId()/organisations",
    component: () => import("/app/pages/projects/[projectId]/organisations/index.vue")
  },
  {
    name: "projects-projectId-organisations___fr",
    path: "/fr/projects/:projectId()/organisations",
    component: () => import("/app/pages/projects/[projectId]/organisations/index.vue")
  }
]